import { render, staticRenderFns } from "./SuggestedPatents.vue?vue&type=template&id=edfe17ba&scoped=true"
import script from "./SuggestedPatents.vue?vue&type=script&lang=js"
export * from "./SuggestedPatents.vue?vue&type=script&lang=js"
import style0 from "./SuggestedPatents.vue?vue&type=style&index=0&id=edfe17ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe17ba",
  null
  
)

export default component.exports